var map = {
	"./background-we-re-here-to-help.svg": 49811,
	"./bg-brand-confetti-repeat.svg": 64925,
	"./branded-callout.svg": 83372,
	"./get-in-touch-callout.webp": 25233,
	"./icon-national-relay-service.png": 70366,
	"./tube-desktop@2x.webp": 34219,
	"./tube-mobile@2x.webp": 61755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2633;